import React from 'react';
import styles from './MainPageCarBrandList.scss';
import Slick from 'react-slick';
import _ from 'lodash';

export default function MobileCarBrandListCarousel({items}) {
  // 21 because we want to have 3 columns with max 7 items in each (see designs)
  const pages = _(items).chunk(21).map((_items) => (
    <div className={styles.carBrandList}>{_items}</div>
  )).value();
  const slickSettings = {
    dots: true
  };
  return (
    <Slick {...slickSettings}>
      {pages}
    </Slick>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/MainPage/elements/MobileCarBrandListCarousel.jsx
 **/